<template>
  <div>
    <h1 class="display-1 font-weight-black primary--text mb-2">
      Portal do Beneficiário
    </h1>
    <p class="subheading">
      Seu usuário está inativo.<br />Insira seu E-mail abaixo para ativalo e
      recuperar a senha.
    </p>
    <v-form ref="form" v-model="valido">
      <v-text-field
        required
        data-cy="recoveryEmailField"
        label="E-mail"
        name="email"
        type="text"
        v-model="email"
        :rules="emailRules"
      ></v-text-field>
    </v-form>
    <v-spacer></v-spacer>
    <v-layout align-center justify-space-between row fill-height>
      <v-btn
        flat
        color="grey darken-1"
        class="body-2 text-none mx-0 px-1"
        :to="{ name: 'acessar' }"
        >Já tenho o acesso</v-btn
      >
      <v-btn
        light
        class="mr-0"
        data-cy="recoverySubmitBtn"
        :color="highContrast ? 'white' : 'primary'"
        :disabled="!valido"
        @click="enviar"
        >Recuperar</v-btn
      >
    </v-layout>
    <p class="mt-4 subheading">
      Primeiro acesso?
      <v-btn
        flat
        color="grey darken-1"
        class="body-2 text-none mx-0 px-1"
        :to="{ name: 'primeiro-acesso' }"
        >Faça seu cadastro novo aqui</v-btn
      >
    </p>
  </div>
</template>

<script>
import auth from "./auth";

export default {
  name: "AcessoInativo",
  props: {
    highContrast: Boolean,
    username: String
  },
  data() {
    return {
      valido: false,
      email: "",
      emailRules: [
        value => !!value || "O E-mail é obrigatório",
        value =>
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || "O E-mail deve ser válido"
      ]
    };
  },
  created() {
    this.checkUsername();
  },
  methods: {
    enviar() {
      if (this.$refs.form.validate()) {
        auth.recuperarSenha(this.email, this.$store);
      }
    },
    checkUsername() {
      if (this.username && this.username.includes("@")) {
        this.email = this.username;
      }
    }
  }
};
</script>
